import React from 'react';
import * as styles from './Spinner.module.scss';
import classNames from 'classnames';
import { isNumber } from 'lodash';

export default function Spinner({ className, ...restProps }) {
  return (
    <div
      className={classNames('spinner', styles.spinner, className)}
      {...restProps}
    >
      <svg
        width="115"
        height="115"
        viewBox="0 0 100 100"
      >
        <circle
          cx="50"
          cy="50"
          r="20"
          fill="none"
          strokeWidth="3"
          strokeMiterlimit="10"
        ></circle>
      </svg>
    </div>
  );
}

const baseSize = parseInt(styles.baseSize);
const baseThickness = parseInt(styles.baseThickness);

export function SmallSpinner({
  size,
  className,
  svgClassName,
  color,
  thickness = baseThickness
}) {
  const wrapperStyle = { color };

  if (isNumber(size) && size !== baseSize) {
    wrapperStyle.width = size;
    wrapperStyle.height = size;
  }

  return (
    <span
      className={classNames(styles.wrapper, className)}
      style={wrapperStyle}
      role="progressbar"
    >
      <svg
        className={classNames(styles.spinner, svgClassName)}
        viewBox={`${baseSize / 2} ${baseSize / 2} ${baseSize} ${baseSize}`}
      >
        <circle
          className={styles.circle}
          cx={baseSize}
          cy={baseSize}
          r={(baseSize - thickness) / 2}
          fill="none"
          strokeWidth={thickness}
        />
      </svg>
    </span>
  );
}
